import { render } from "./AddEditPbSchool.vue?vue&type=template&id=b8370a62&scoped=true"
import script from "./AddEditPbSchool.vue?vue&type=script&lang=js"
export * from "./AddEditPbSchool.vue?vue&type=script&lang=js"

import "./AddEditPbSchool.vue?vue&type=style&index=0&id=b8370a62&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8370a62"]])

export default __exports__